import React from 'react';
import { CPRAOptOutPage } from '../../components/CPRAOptOutPage';
import { CpraSettings } from '../../../lib/cpraService';

export interface AppProps {
  cpraSettings: CpraSettings;
}

const App: React.FC<AppProps> = ({ cpraSettings }) => <CPRAOptOutPage isCPRAOptOut={cpraSettings.stopSharingData} />;

export default App;
